import { SvgIcon } from '@mui/material';
import React from 'react';

const DesiredShippingDateIcon = (props) => {
  return (
    <SvgIcon
      {...props}
      width="36"
      height="31"
      viewBox="0 0 36 31"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M23.3651 4.7707H20.5462V2.72652C20.5462 2.34614 20.2116 1.98318 19.8189 2.0006C19.6272 2.00432 19.4444 2.08199 19.3088 2.21733C19.1732 2.35267 19.0954 2.53516 19.0916 2.72652V4.7707H8.90982V2.72652C8.90982 2.34614 8.57527 1.98318 8.18255 2.0006C7.99083 2.00432 7.808 2.08199 7.67241 2.21733C7.53682 2.35267 7.459 2.53516 7.45527 2.72652V4.7707H4.63636C3.67229 4.77185 2.74804 5.15462 2.06634 5.83505C1.38464 6.51548 1.00115 7.43801 1 8.40028V24.3704C1 26.3725 2.632 28 4.63636 28H23.3636C25.3695 28 27 26.3725 27 24.3704V8.40028C27 7.4379 26.6171 6.51493 25.9354 5.83429C25.2538 5.15365 24.3293 4.77108 23.3651 4.7707ZM4.63636 6.22253H7.45527V7.08201C7.45527 7.46239 7.78982 7.82535 8.18255 7.80793C8.57673 7.79051 8.90982 7.48853 8.90982 7.08201V6.22253H19.0916V7.08201C19.0916 7.46239 19.4262 7.82535 19.8189 7.80793C20.2131 7.79051 20.5462 7.48853 20.5462 7.08201V6.22253H23.3636C24.5665 6.22253 25.5455 7.19961 25.5455 8.40028V10.7H2.45455V8.40028C2.45455 7.19961 3.43345 6.22253 4.63636 6.22253ZM23.3651 26.5482H4.63636C3.43345 26.5482 2.45455 25.5711 2.45455 24.3704V12.1518H25.5455V24.3704C25.5455 24.9477 25.3158 25.5014 24.9069 25.9098C24.4981 26.3182 23.9435 26.5478 23.3651 26.5482Z"
        fill="currentColor"
        strokeWidth="0.1"
      />
      <path
        d="M32.36 14.64C30.68 12.96 28.4 12 26 12C23.6 12 21.32 12.96 19.64 14.64C17.96 16.32 17 18.6 17 21C17 23.4 17.96 25.68 19.64 27.36C21.32 29.04 23.6 30 26 30C28.4 30 30.68 29.04 32.36 27.36C34.04 25.68 35 23.4 35 21C35 18.6 34.04 16.32 32.36 14.64Z"
        fill="#FF7043"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M29.4616 16.4506L30.5494 17.5384C31.1502 18.1392 31.1502 19.1132 30.5494 19.714L29.6247 20.6386L26.3614 17.3752L27.286 16.4506C27.8868 15.8498 28.8608 15.8498 29.4616 16.4506ZM25.8175 17.9191L21.6498 22.0868C21.4019 22.3347 21.2462 22.6597 21.2082 23.0081L21.0062 24.8633C20.9352 25.5148 21.4852 26.0648 22.1368 25.9938L23.9919 25.7918C24.3403 25.7538 24.6653 25.5981 24.9131 25.3503L29.0808 21.1825L25.8175 17.9191Z"
        fill="white"
      />
    </SvgIcon>
  );
};

export default DesiredShippingDateIcon;
